const { defaultTopicIconColor: badgeColor } = settings;

export default class Badge {
    color = badgeColor;

    title: string;
    icon: string;    

    constructor(title: string, icon: string) {
        this.title = title;
        this.icon = icon;
    }
}